import FirebaseContext, { withFirebase } from './context';
import * as collections from './collections';
import Firebase from './Firebase';
import { analytics } from 'firebase';

export default Firebase;
export const firebaseAnalytics = analytics();

export { FirebaseContext, withFirebase, collections };
